import { render } from "./GiftCardSettings.vue?vue&type=template&id=270a8dda"
import script from "./GiftCardSettings.vue?vue&type=script&lang=js"
export * from "./GiftCardSettings.vue?vue&type=script&lang=js"

import "./GiftCardSettings.vue?vue&type=style&index=0&id=270a8dda&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__